import { render, staticRenderFns } from "./VcaTrendSignal.vue?vue&type=template&id=2f437e3a&scoped=true"
import script from "./VcaTrendSignal.vue?vue&type=script&lang=ts"
export * from "./VcaTrendSignal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f437e3a",
  null
  
)

export default component.exports